(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationWorkflowStepDeleteController',CommunicationWorkflowStepDeleteController);

    CommunicationWorkflowStepDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationWorkflowStep'];

    function CommunicationWorkflowStepDeleteController($uibModalInstance, entity, CommunicationWorkflowStep) {
        var vm = this;

        vm.communicationWorkflowStep = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationWorkflowStep.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
